var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learning-box"},[_c('div',{staticClass:"editor-arrow"},[_c('route-back',{on:{"click":_vm.routeBack}})],1),_c('div',{staticClass:"learning-box__body-head-wrapper"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }